var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._g(_vm._b({attrs:{"expand":"","nav":""}},'v-list',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.items),function(item,i){return [(item.items)?_c('default-list-group',{key:`group-${i}`,attrs:{"item":item}}):(_vm.checkActivePart(item.part))?_c('default-list-item',{key:`item-${i}`,attrs:{"item":item}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }